import { render, staticRenderFns } from "./_base-reportLinks.vue?vue&type=template&id=5da65ffa&scoped=true"
import script from "./_base-reportLinks.vue?vue&type=script&lang=js"
export * from "./_base-reportLinks.vue?vue&type=script&lang=js"
import style0 from "./_base-reportLinks.vue?vue&type=style&index=0&id=5da65ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da65ffa",
  null
  
)

export default component.exports